module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "teams-creation.36005a00.png" + "?" + Date.now();